import React from "react";
import {
  HomeSlider,
  TopProgrammes,
  PeopleBehind,
  EventGallery,
  // OurNews,
  VisionSection,
  MissionSection,
  PhotoGallery2,
  FoundationFacts,
  MoreAboutFoundation,
  AudioSection,
  BookSection,
  Certificates,
  NewsArticles,
} from "../components/index";
import SocialLinks from "../components/HomeComponents/SocialLinkss/SocialLinks";

const HomePage = () => {
  return (
    <>
      <div className="App">
        <HomeSlider />
        <TopProgrammes />
        <BookSection />
        <PeopleBehind />
        <EventGallery />
        <VisionSection />
        <NewsArticles />
        {/* <OurNews /> */}
        <SocialLinks />
        <MissionSection />
        <Certificates/>
        <PhotoGallery2 />
        <FoundationFacts />
        <MoreAboutFoundation />
        <AudioSection />
      </div>
    </>
  );
};

export default HomePage;
